import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { activity_details, activity_path, activity_related_packages } from "../../redux/commonReducer";
import { getActivityDetails } from "../../redux/commonActionCreator";
import { IMAGE_BASE_URL } from "../../constants/configuration";
import { activity } from "../../components/web/config";

export default function ActivityDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, packageId } = useParams();

  const details = useSelector(activity_details);
  const path = useSelector(activity_path);
  const packages = useSelector(activity_related_packages)

  const INITIAL_LIMIT = 5;
  const [visiblePackages, setVisiblePackages] = useState(INITIAL_LIMIT);

  const handleLoadMore = () => {
    setVisiblePackages(packages.length);
  };

  useEffect(() => {
    if (id) {
      if (packageId) {
        const row = {
          id,
          packageId,
        };
        dispatch(getActivityDetails(row));
      } else {
        dispatch(getActivityDetails(id));
      }
    }
  }, [id]);

  return (
    <div className="section__activities">
      <img
        className="main"
        src={`${IMAGE_BASE_URL}${path}/${details?.image}`}
        alt={details?.image_alt}
      />
      <div className="container">
        <div className="row">
          <div className={`${packages?.length == undefined || packages?.length == 0 ? "col-md-12" : 'col-md-8'}`}>
            <div
              className={`tag ${details?.activities?.length ? "pointer" : ""}`}
              onClick={() =>
                details?.activities?.length
                  ? navigate(
                    `/activity-details/${details?.activities?.[0].handle_key}`
                  )
                  : {}
              }
            >
              Activities
            </div>
            <h1>
              {details?.title}
            </h1>
            <h6>
              {" "}
              <img src="/assets/img/icons/clock.svg" alt="" /> Duration{" "}
              {details?.duration} hours
            </h6>
            <h2>
              Details
            </h2>
            <div
            className="detail-para ql-editor"
              dangerouslySetInnerHTML={{ __html: details?.long_description }}
            ></div>
          </div>
          {
            packages?.length > 0 &&
            <div className="col-md-4">
              <div className="related__packages">
                <h2>Related Packages</h2>
                {packages.slice(0, visiblePackages).map((ele, i) => (
                  <Link to={`/package-details/${ele?.handle_key}`} key={i}>
                    <div className="packages">
                      <div className="image">
                        <img
                          src={
                            ele?.thumbnail
                              ? `${IMAGE_BASE_URL}package/${ele?.thumbnail}`
                              : ""
                          }
                          alt=""
                        />
                      </div>
                      <div className="title">
                        <h3>{ele?.package_name}</h3>
                      </div>
                    </div>
                  </Link>
                ))}
                {visiblePackages < packages.length && (
                  <button onClick={handleLoadMore} className="loadmore">
                    Load More..
                  </button>
                )}
              </div>
            </div>
          }
        </div>

      </div>
      {details?.activities?.length ? (
        <div className="more_activities">
          <div className="container">
            <h3>MORE ACTIVITIES</h3>
            <Slider {...activity}>
              {details?.activities?.map((ele, i) => {
                return (
                  <div
                    className="gridItem"
                    onClick={() =>
                      navigate(`/activity-details/${ele?.handle_key}`)
                    }
                  >
                    <img
                      src={`${IMAGE_BASE_URL}${path}/${ele?.image}`}
                      alt={ele.image_alt}
                    />
                    <h4>{ele?.title}</h4>
                    <h6>
                      {" "}
                      <img
                        src="/assets/img/icons/clock.svg"
                        alt=""
                      /> Duration {ele?.duration} hours
                    </h6>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
